// extracted by mini-css-extract-plugin
export default {"wrapper":"Metric_wrapper__t7FJe","icon":"Metric_icon__U4NVE","label":"Metric_label__k2kFq","value":"Metric_value__pRBL8"};